<template>
    <div class="" id="Evaluation">
        <mt-header title="估价">
            <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
        </mt-header>
        <mt-cell title="品牌车系" is-link>
            <span>品牌类型</span>
        </mt-cell>
        <hr>
        <mt-cell title="上牌时间" @click="openPicker">
            <span>选择时间</span>
        </mt-cell>
        <hr>
        <mt-cell title="行驶里程">
            <input type="text" pattern="请输入行驶里程">
            <span>万里</span>
        </mt-cell>
        <hr>
        <mt-cell title="所在城市" is-link>
            <span>所在城市</span>
        </mt-cell>
        <hr>
        <div class="but">
            <button>确认提交</button>
        </div>
        <mt-datetime-picker 
         ref="picker"
         type="time"
         @confirm="onConfirm"
          v-model="body.firstLicenseDateStr">
        </mt-datetime-picker>
    </div>
</template>

<script>
import { Swipe, SwipeItem, Header, Cell, DatetimePicker } from "mint-ui";
import moment from 'moment'// 格式化时间
import Vue from 'vue'
Vue.component(DatetimePicker.name, DatetimePicker)
export default {
    name: "Evaluation",
    data() {
        return {
            body: {
                firstLicenseDateStr: undefined
            }
        };
    },
    methods: {
        goback: function() {
            window.history.go(-1);
        },
        openPicker: function() {
            alert('openPicker')
            console.log('12121')
            this.$refs.picker.open();
        },
        onConfirm: function() {
            this.$refs.picker.close();
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
    color: #2c2c2c;
}
html {
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Evaluation.vue